module.exports = __webpack_public_path__ + "static/media/contacts.d722a20a.gif";